import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';
import { useUpdateTotalNotification } from '../../utils/useUpdateTotalNotification';

// PACKAGES
import { useHistory } from 'react-router';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../components/Button';
import LoadingSpinner from '../../components/LoadingSpinner';

// ICONS
import { ReactComponent as AlertIcon } from '../../assets/svg/alert.svg';

// TYPES
import { closeModalType } from '../../components/GlobalModal';

interface DenyModalTypes {
	isVolunteer?: boolean;
	id?: string;
	firstName?: string;
	lastName?: string;
	closeModal?: closeModalType;
}

const DenyModal: React.FC<DenyModalTypes> = ({ closeModal, isVolunteer, id, firstName, lastName }) => {
	const history = useHistory();

	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const confirmDeny = async () => {
		setIsLoading(true);

		if (isVolunteer) {
			const response = await apibridge.postRequestsToJoinVolunteerDeny({
				userProfileId: id
			});

			if (response.isError) {
				setIsLoading(false);

				setFormErrorMessage(
					response.validationErrors.length
						? validationErrorsToString(response.validationErrors)
						: response.message || 'An error has occurred'
				);
			} else {
				useUpdateTotalNotification();

				setIsLoading(false);

				history.push('/requests-to-join');
			}
		} else {
			const response = await apibridge.denyRequestsToJoin({
				profileId: id
			});

			if (response.isError) {
				setIsLoading(false);

				setFormErrorMessage(
					response.validationErrors.length
						? validationErrorsToString(response.validationErrors)
						: response.message || 'An error has occurred'
				);
			} else {
				useUpdateTotalNotification();

				setIsLoading(false);

				history.push('/requests-to-join');
			}
		}
	};

	return (
		<div className="modal-confirmation">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<h2 className="heading h4">
									Are you sure you wish to deny{' '}
									<strong className="text-capitalized">
										'{firstName} {lastName}'
									</strong>
								</h2>

								<section className="actions">
									<Button className="btn-primary full-width" onClick={confirmDeny}>
										Yes
									</Button>

									<Button className="btn-secondary full-width" onClick={closeModal}>
										Cancel
									</Button>
								</section>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default DenyModal;
